import { NavbarMenuItem } from '@shared/utils/menu-items';
import { PreviewUserHeadingServiceBase, UserHeading } from '../../services/preview-user-heading/preview-user-heading.service';
import { Observable, Subject } from 'rxjs';
import { Renderer2 } from '@angular/core';
import { StaticPropsComponentExtensions } from '@shared/feature/component-static-extensions';

export abstract class LayoutSharedComponent extends StaticPropsComponentExtensions {
  menuItems: NavbarMenuItem[] = [];
  user$: Observable<UserHeading>;
  favIcon: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
  isLoading = true;

  protected isFullScreen = false;
  protected miniNavbar = false;
  protected ngUnsubscribe$ = new Subject<void>();

  protected readonly URL_PATTERN = /files\/(?!processing|deletion|upload)([\w-]+)(\?.*)?$/;

  constructor(protected user: PreviewUserHeadingServiceBase, protected renderer: Renderer2) {
    super();
    this.user$ = this.user.getUserData();
  }

  navbarToggle(): void {
    if (this.miniNavbar) {
      this.renderer.removeClass(document.body, 'mini-navbar');
    } else {
      this.renderer.addClass(document.body, 'mini-navbar');
    }
    this.miniNavbar = !this.miniNavbar;
  }

  isSideBarHidden(): string {
    return this.isFullScreen ? 'app-hide-navmenu' : '';
  }

  isNavMenuHidden(): string {
    return this.isFullScreen ? 'onoffswitch-checkbox' : '';
  }
}
